<template>
<div class="login">
    <div id="login_nav">
        <div id="login-headline">
            <h3>Ready? Let&rsquo;s go.</h3>
        </div>
        <div v-if="step <= 1" class="already-have-account">
            <p><a href="/login">Already have an account? Login &rarr;</a></p>
        </div>
        <a id="step-one" :class="{selected:step===1}" href="#step_paying_for" @click="changeStep(1)"><span>1</span> Choose Registration Type</a>
        <a id="step-two" :class="{selected:step===2}" href="#step_login" @click="changeStep(2)"><span>2</span> Create TRAC Account</a>
        <a id="step-three" v-if="!prepay" :class="{selected:step===3}" href="#step_pay" @click="changeStep(3)"><span>3</span> Pay</a>
    </div>
    <form id="form_start" method="POST" action="/start">
        <div id="step_account_type" v-show="step === 0">
            <p class="is-big">What kind of report would you like?</p>
            <small class="pricing_link"><a href="#pricing" data-kube="toggle" data-target="#pricing">Not sure which report is right for you?</a></small>
            <input v-model="account_type" type="radio" name="account_type" value="full" id="type_full_report" class="is-hidden">
            <label for="type_full_report">FULL REPORT &mdash; US ${{ fullReportPrice }}</label>
            <input v-model="account_type" type="radio" name="account_type" value="summary" id="type_summary" class="is-hidden">
            <label for="type_summary">SUMMARY &mdash; US ${{ summaryPrice }}</label>
        </div>
        <div id="step_paying_for" v-show="step === 1">
            <p class="is-big">Are you registering to take TRAC for yourself, or are you registering on behalf of someone else?</p>
            <input v-model="paying_for" type="radio" name="paying_for" value="self" id="paying_for_self" class="is-hidden">
            <label for="paying_for_self">I&rsquo;m registering for myself</label>
            <input v-model="paying_for" type="radio" name="paying_for" value="other" id="paying_for_other" class="is-hidden">
            <label for="paying_for_other">I&rsquo;m registering for someone else</label>
        </div>
        <div id="step_login" v-show="step === 2">
            <label for="login_first_name" class="is-hidden">{{ paying_for === "other" ? "Participant's First Name" : "First Name" }}</label>
            <input v-model="first_name" id="login_first_name" type="text" name="first_name" :placeholder="paying_for === 'other' ? 'Participant\'s First Name' : 'First Name'">
            <label for="login_last_name" class="is-hidden">{{ paying_for === "other" ? "Participant's Last Name" : "Last Name" }}</label>
            <input v-model="last_name" id="login_last_name" type="text" name="last_name" :placeholder="paying_for === 'other' ? 'Participant\'s Last Name' : 'Last Name'">
            <label for="login_email" class="is-hidden">{{ paying_for === "other" ? "Participant's Email" : "Email" }}</label>
            <input id="login_email" type="text" name="email" v-model="email" :placeholder="paying_for === 'other' ? 'Participant\'s Email Address' : 'Email Address'">
            <label for="login_email_confirm" class="is-hidden">Confirm Email</label>
            <input v-model="email_confirm" id="login_email_confirm" type="text" name="email_confirm" placeholder="Confirm Email Address">
            <small v-if="paying_for !== 'other'">You&rsquo;ll use this email to sign in to your account, so make sure it is correct.</small>
            <small v-else>The participant will use this email to sign in to their account, so make sure it is correct.</small>
            <div id="age-wrapper">
                <label class="is-big">{{ paying_for === "other" ? "What is the participant's age range?" : "What is your age range?" }}</label>
                <input v-model="age" id="login_age_18" type="radio" name="age" value="18" class="is-hidden">
                <label for="login_age_18" class="age">18-25</label>
                <input v-model="age" id="login_age_26" type="radio" name="age" value="26" class="is-hidden">
                <label for="login_age_26" class="age">26-35</label>
                <input v-model="age" id="login_age_36" type="radio" name="age" value="36" class="is-hidden">
                <label for="login_age_36" class="age">36-50</label>
                <input v-model="age" id="login_age_50" type="radio" name="age" value="50" class="is-hidden">
                <label for="login_age_50" class="age">50+</label>
            </div>
            <div id="coach-wrapper">
                <div v-show="paying_for !== 'other'">
                    <label class="is-big">Are you working with a coach?</label>
                    <input id="login_have_coach_yes" type="radio" name="have_coach_yes" value="Yes" v-model="have_coach" class="is-hidden">
                    <label for="login_have_coach_yes">Yes</label>
                    <input id="login_have_coach_no" type="radio" name="have_coach_no" value="No" v-model="have_coach" class="is-hidden">
                    <label for="login_have_coach_no">No</label>
                </div>
                <div id="login_coach" v-show="have_coach && have_coach !== 'No'">
                    <label for="login_coach_name" class="is-hidden">Coach Name</label>
                    <input v-model="coach_name" id="login_coach_name" type="text" name="coach_name" :placeholder="paying_for === 'other' ? 'Your Name' : 'Your Coach\'s Name'">
                    <label for="login_coach_email" class="is-hidden">Coach Email</label>
                    <input v-model="coach_email" id="login_coach_email" type="text" name="coach_email" :placeholder="paying_for === 'other' ? 'Your Email Address' : 'Your Coach\'s Email Address'">
                </div>
            </div>
            <small class="terms">By continuing, you are agreeing to our <a href="#" data-kube="toggle" data-target="#terms-window">Terms of Service and Privacy Notice.</a></small>
            <div id="terms-window" class="is-hidden">
                <h4>
                    Terms and Conditions of Use
                </h4>
                <p>
                    <strong>1. Terms</strong><br>
                    By accessing this web site, you are agreeing to be bound by these web site Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this web site are protected by applicable copyright and trade mark law.
                </p>
                <p>
                    <strong>2. Use License</strong>
                </p>
                <ol type="a">
                    <li>Permission is granted to temporarily download one copy of the materials (information or software) on Leader Breakthru, Inc.'s web site for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                        <ol type="i">
                            <li>modify or copy the materials;
                            </li>
                            <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
                            </li>
                            <li>attempt to decompile or reverse engineer any software contained on Leader Breakthru, Inc.'s web site;
                            </li>
                            <li>remove any copyright or other proprietary notations from the materials; or
                            </li>
                            <li>transfer the materials to another person or "mirror" the materials on any other server.
                            </li>
                        </ol>
                    </li>
                    <li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Leader Breakthru, Inc. at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.
                    </li>
                </ol>
                <p>
                    <strong>3. Disclaimer</strong>
                </p>
                <ol type="a">
                    <li>The materials on Leader Breakthru, Inc.'s web site are provided "as is". Leader Breakthru, Inc. makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights. Further, Leader Breakthru, Inc. does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its Internet web site or otherwise relating to such materials or on any sites linked to this site.
                    </li>
                </ol>
                <p>
                    <strong>4. Limitations</strong><br>
                    In no event shall Leader Breakthru, Inc. or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption,) arising out of the use or inability to use the materials on Leader Breakthru, Inc.'s Internet site, even if Leader Breakthru, Inc. or a Leader Breakthru, Inc. authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
                </p>
                <p>
                    <strong>5. Revisions and Errata</strong><br>
                    The materials appearing on Leader Breakthru, Inc.'s web site could include technical, typographical, or photographic errors. Leader Breakthru, Inc. does not warrant that any of the materials on its web site are accurate, complete, or current. Leader Breakthru, Inc. may make changes to the materials contained on its web site at any time without notice. Leader Breakthru, Inc. does not, however, make any commitment to update the materials.
                </p>
                <p>
                    <strong>6. Site Terms of Use Modifications</strong><br>
                    Leader Breakthru, Inc. may revise these terms of use for its web site at any time without notice. By using this web site you are agreeing to be bound by the then current version of these Terms and Conditions of Use.
                </p>
                <p>
                    <strong>7. Governing Law</strong><br>
                    Any claim relating to Leader Breakthru, Inc.'s web site shall be governed by the laws of the State of California in the United States of America without regard to its conflict of law provisions.
                </p>
                <h4>
                    Privacy Policy
                </h4>
                <p>
                    Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to understand how we collect, use, communicate and disclose and make use of personal information. The following outlines our privacy policy.
                </p>
                <ul>
                    <li>Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.
                    </li>
                    <li>We will collect and use of personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned or as required by law.
                    </li>
                    <li>We will only retain personal information as long as necessary for the fulfillment of those purposes.
                    </li>
                    <li>We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.
                    </li>
                    <li>Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.
                    </li>
                    <li>We will protect personal information by reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.
                    </li>
                    <li>We will make readily available to customers information about our policies and practices relating to the management of personal information.
                    </li>
                </ul>
                <p>
                    We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.
                </p>

            </div>
            <div v-show="submit_clicked && firstError" class="alert is-error">
                {{firstError}}
            </div>
            <button @click.prevent="pay">{{ buttonText }}</button>
        </div>
    </form>
    <div v-if="step === 0" style="display:none;" id="pricing">
        <div class="is-row is-gapless">
            <div id="Summary-Report" class="pricing-table is-col">
                <h4>Summary</h4>
                <p>For those who want a basic understanding of where they need the most help.</p>
                <p class="price"><strong>US${{ summaryPrice }}</strong></p>
                <p class="price-note">Upgrade for ${{ upgradePrice }}</p>
                <p>TRAC360&deg; Assessment</p>
                <p>Assessment Results</p>
                <p>Interpretive Guide</p>
                <p class="download"><a href="/TRAC-Summary-Sample.pdf">Download Sample Report</a></p>
                <a href="#" @click="selectType('summary');" class="button is-secondary">Select</a>
                <p class="footnote"><small>Upgrade to the Full Report at any time to gain access to coaching videos, personalized coaching plan and more.</small></p>
            </div>
            <div id="Full-Report" class="pricing-table is-col">
                <h3>Recommended</h3>
                <h4>Full Report</h4>
                <p>For those looking to break through to the next level of their personal development.</p>
                <p class="price"><strong>US${{ fullReportPrice }}</strong></p>
                <p class="price-note"><s>US${{ fullReportPriceNonSale }}</s><span> Save {{ percentSaving }}%</span></p>
                <p>TRAC360&deg; Assessment</p>
                <p>Assessment Results</p>
                <p>Personalized TRAC Report</p>
                <p>Interpretive Guide</p>
                <p>Critical Issue(s) Identified</p>
                <p>Pesonalized Coaching Plan</p>
                <p>Access to Coaching Videos</p>
                <p>Digital copy of the book <a href="https://amzn.to/2U2p6m7" target="_blank"><em>TRAC</em></a> by Terry B. Walling</p>
                <p class="download"><a href="/TRAC-Report-Sample.pdf">Download Sample Report</a></p>
                <a href="#" @click="selectType('full');" class="button is-secondary">Select</a>
            </div>
        </div>
        <div id="guarantee" class="content">
            <p>More than anything, we want TRAC to be a help for you as you look to find clarity and breakthrough in your personal development. If you are not satisfied with this assessment tool, email us (<a href="mailto:help@taketrac.com"><em>help@taketrac.com</em></a>) and we’ll refund your money.</p>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

export default {
    name: 'Login',
    components: {
    },
    data: () => {
        return {
            account_type: '',
            paying_for: '',
            age: '',
            have_coach: 0,
            agree_terms: 0,
            stripeHandler: null,
            config: {},
            email: '',
            step: 0,
            first_name: '',
            last_name: '',
            email_confirm: '',
            coach_name: '',
            coach_email: '',
            submit_clicked: false,
            list_price: 0
        }
    },
    mounted: async function() {
        const res = await Axios.get('/config');
        this.config = res.data;
        if (this.config.email) {
            this.email = this.config.email;
            this.email_confirm = this.config.email;
        }

        this.stripeHandler = StripeCheckout.configure({
            key: this.config.key,
            locale: 'auto',
            token: this.stripeResponse
        });
        if (!this.showLimited()) {
            this.step = 1;
        }
        if (this.prepay) {
            this.step = 2;
            this.paying_for = 'self';
            if (this.config.prepay_limited) {
                this.account_type = 'summary';
            } else {
                this.account_type = 'full';
            }
        }
    },
    computed: {
        validationResult: function () {
            const result = {};
            if (!this.first_name || !this.last_name) {
                result['login_first_name'] = this.paying_for === 'other' ? 'Please enter participant\'s name' : 'Please enter your name';
            }
            if (!this.email) {
                result['login_email'] = this.paying_for === 'other' ? 'Please enter participant\'s email address' : 'Please enter your email address';
            }
            if (this.email !== this.email_confirm) {
                result['login_email_confirm'] = 'The email confirmation doesn\'t match. Please double check.';
            }
            if (!this.age) {
                result['age'] = this.paying_for === 'other' ? 'Please select participant\'s age range' : 'Please select your age range';
            }
            if (this.paying_for !== 'other' && !this.have_coach) {
                result['have_coach'] = 'Please indicate if you are working with a coach';
            }
            if ((this.have_coach === 'Yes' || this.paying_for === 'other') && (!this.coach_name || !this.coach_email)) {
                result['coach_name'] = this.paying_for === 'other' ? 'Please enter your information' : 'Please enter coach\'s information';
            }
            if ((this.have_coach === 'Yes' || this.paying_for === 'other') && !this.validateEmail(this.coach_email)) {
                result['coach_email'] = 'Please enter a valid email address';
            }
            return result;
        },
        firstError: function() {
            for(var key in this.validationResult) {
                return this.validationResult[key];
            }
            return '';
        },
        prepay: function() {
            return this.config.prepay;
        },
        buttonText: function() {
            return this.prepay ? 'Agree & Continue' : 'Agree & Continue to Payment';
        },
        price: function() {
            if (this.paying_for !== 'other' || this.list_price <= 0 || this.account_type === 'summary') {
                return this.account_type === 'summary' ? this.config.summary_amount : this.config.amount;
            } else {
                return this.list_price;
            }
        },
        fullReportPrice: function() {
            return this.config.amount / 100;
        },
        fullReportPriceNonSale: function() {
            return this.config.amount_non_sale / 100;
        },
        summaryPrice: function() {
            return this.config.summary_amount / 100;
        },
        percentSaving: function() {
            return Math.floor((this.config.amount_non_sale - this.config.amount) / this.config.amount_non_sale * 100);
        },
        upgradePrice: function() {
            return this.config.upgrade_price / 100;
        }
    },
    methods: {
        pay: function () {
            this.submit_clicked = true;
            if (this.firstError) {
                return false;
            }
            if (this.prepay) {
                const form = document.getElementById('form_start');
                const formData = new FormData(form);
                const router = this.$router;
                Axios.post('/start', formData).then(function (response) {
                    if (response.data && response.data.success) {
                        router.push('start');
                    }
                });
                return;
            }
            
            this.stripeHandler.open({
                name: this.config.name,
                description: this.config.description,
                amount: this.price,
                email: this.paying_for === 'other' ? this.coach_email : this.email,
                allowRememberMe: false
            });
        },
        changeStep: function (step) {
            this.step = step;
        },
        stripeResponse: function (token) {
            // You can access the token ID with `token.id`.
                // Get the token ID to your server-side code for use.
                const form = document.getElementById('form_start');
                const formData = new FormData(form);
                const router = this.$router;
                formData.append("stripeToken", token.id);
                Axios.post('/start', formData).then(function (response) {
                    if (response.data && response.data.success) {
                        router.push('start');
                    }
                });
        },
        fetchCoach: async function() {
            const res = await Axios.get('/coach', {
                    params: {
                        e: this.coach_email
                    }
                });
            const price = res.data && res.data.price;
            if (price) {
                this.list_price = price;
            }
        },
        validateEmail: function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        showLimited: function() {
            return this.config.show_limited || window.location.search.indexOf('show_limited') >= 0;
        },
        selectType: function(type) {
            this.account_type = type;
        }
    },
    watch: {
        account_type: function(newVal, oldVal) {
            if (newVal && this.step === 0) {
                this.step = 1;
            }
        },
        paying_for: function(newVal, oldVal) {
            if (newVal && this.step === 1) {
                this.step = 2;
            }
            if (newVal === 'other') {
                this.have_coach = true;
            }
        },
        coach_email: async function() {
            if (this.coach_email
                && this.paying_for === 'other'
                && this.validateEmail(this.coach_email)) {
                await this.fetchCoach();
            }
        }
    }
}
</script>
